import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'editIntegrationDrawer.title',
    defaultMessage: 'Edit integration',
    description: 'Title of the edit integration drawer',
  },
  feedback: {
    integrationUpdated: {
      id: 'editIntegrationDrawer.feedback.integrationUpdated',
      defaultMessage: 'Integration updated',
      description: 'Success message of the edit integration action',
    },
    integrationNotUpdated: {
      id: 'editIntegrationDrawer.feedback.integrationNotUpdated',
      defaultMessage: 'Integration could not be updated',
      description: 'Error message of the edit integration action',
    },
  },
};

export default defineMessages(translations);
